import { EventBus } from "../../hermeneus.eventbus/eventbus";
import axios from "axios";
import { haxiosAPIClient } from "@/haxios/haxios.js";

/**
 * Stellt die ModuleRegistry als Global Property zur Verfügung
 */
export let providesModuleRegistryPlugin = {
    install: function (app, options) {
        app.config.globalProperties.$ModuleRegistry = {
            ...window.ModuleRegistry || false,
            get: function (ModuleAlias) {
                return app.config.globalProperties.$resolveModuleFromRegistry(ModuleAlias);
            }
        };
        app.config.globalProperties.$fetchModuleRegistry = async () => {
            try {
                const response = await haxiosAPIClient.get('/modules/registry')
                app.config.globalProperties.$ModuleRegistry = response.data;
            } catch (error) {
                console.error('Fehler beim Laden der ModuleRegistry:', error);
            }

        };

        /**
         * Ermittelt ein Modul aus der ModuleRegistry anhand des Models
         * @param ModuleAlias
         * @returns {Object}
         */
        app.config.globalProperties.$resolveModuleFromRegistry = function (ModuleAlias) {
            if (!this.$ModuleRegistry) {
                console.log('ModuleRegistry ist nicht gesetzt.');
            } else {

                return Object.entries(this.$ModuleRegistry).filter((Module) => {
                    return Module[0] === ModuleAlias;
                })[0][1];
            }
        };


        /**
         * Prüft ob ein Modul existiert
         * @param ModuleAlias
         * @returns {boolean}
         */
        app.config.globalProperties.$moduleExists = function (ModuleAlias) {
            if (Object.entries(this.$ModuleRegistry).filter((Module) => {
                return Module[0] === ModuleAlias;
            }).length > 0) {
                return true;
            }
            return false;
        };



        /**
         * Prüft ob alle Module aus dem übergebenen Array in der Registry existieren
         * @param {string[]} ModuleAliasesArray - Array von Modul-Aliasen
         * @returns {boolean} - True wenn alle Module existieren, sonst False
         * @throws {Error} - Wenn ModuleAliasesArray kein Array ist
         */
        app.config.globalProperties.$modulesExist = function (ModuleAliasesArray) {
            if (!Array.isArray(ModuleAliasesArray)) {
                throw new Error('ModuleAliasesArray muss ein Array sein');
            }

            if (ModuleAliasesArray.length === 0) return true;

            const registryModules = Object.keys(this.$ModuleRegistry);
            return ModuleAliasesArray.every(alias => registryModules.includes(alias));
        };

    },

}